import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignupService {
  constructor(private apiService: ApiService) {}

  signup(name: string, email: string, password: string, phone: string): Observable<any> {
    const signupData = {
      Name: name,
      Email: email,
      Password: password,
      PhoneNumber: phone,
    };
    return this.apiService.post(`/v1/users`, signupData);
  }

  getOrgName(email: string): Observable<any> {
    return this.apiService.get(`/v1/organizations/by-domain?email=${email}`);
  }

  fetchOtp(email: string): Observable<any> {
    const fetchOtpData = {
      email: email,
    };
    return this.apiService.post(`/v1/auth/validate-email`, fetchOtpData);
  }

  validateOtp(email: string, otpCode: string): Observable<any> {
    const validateOtpData = {
      email: email,
      code: otpCode,
    };
    return this.apiService.post(`/v1/auth/validate-code`, validateOtpData);
  }
}
